import React, {useEffect, useState} from "react";
import Image from "next/image";
import Link from "next/link";
import "tippy.js/dist/tippy.css";
import Auctions_dropdown from "../dropdown/Auctions_dropdown";
import {useRouter} from "next/router";
import {getProjects, getWalletBalances} from "../../utils/api";
import ExchangeData from "../../data/exchange_data";
import {getAccountHolderId, getUserId} from "../../utils/jwtUtil";

const CategoryItem = ({userId}) => {
    const router = useRouter();
    
    const [dataToRender, setDataToRender] = useState(null);
    const [accountHolderId, setAccountHolderId] = useState(null);
    const [walletBalancesForUser, setWalletBalancesForUser] = useState(null);

    const { data: projectsData, error: projectsError } = getProjects();
    const { data: walletBalancesData, error: walletBalancesError} = getWalletBalances(accountHolderId);

    useEffect(() => {
        setAccountHolderId(getAccountHolderId());
    },[]);

    useEffect(() => {
        if (walletBalancesData && Array.isArray(walletBalancesData)) {
            setWalletBalancesForUser(walletBalancesData.filter(x => x.walletAccountType === "Server"));
        }
    },[walletBalancesData]);

    useEffect(() => {
        if (!router.isReady || !projectsData || !Array.isArray(projectsData)) return;

        if (userId) {
            setDataToRender(projectsData.filter((item) => item.accountHolderId === accountHolderId));
        } else {
            setDataToRender(projectsData);
        }

    }, [router.isReady, projectsData]);
    
    return (
        <div className="grid grid-cols-1 gap-[1.875rem] md:grid-cols-2 lg:grid-cols-4">
            {dataToRender && dataToRender.length === 0 ? (
                <article>
                    <div
                        className="dark:bg-jacarta-700 dark:border-jacarta-700 border-jacarta-100 rounded-2.5xl block border bg-white p-[1.1875rem] transition-shadow hover:shadow-lg">
                        <figure className="relative">
                            No projects for this user
                        </figure>
                    </div>
                </article>
            ) : (dataToRender && dataToRender.map((item) => {
                const {
                        projectId,
                        calcCADRMinted,
                        projectName,
                        blockchainAddressActive,
                        accountHolderId,
                    } = item;
                const userLocale = navigator.language || 'en-AU';
                const imageUrl = `/images/projects/${projectId}.webp`;
                const isOwner = accountHolderId === getAccountHolderId();

                const calcCADRMintedAsString = new Intl.NumberFormat(userLocale).format(calcCADRMinted);
                const itemLink = projectId
                    ?.split("/")
                    .slice(-1)
                    .toString()
                    .replace(".jpg", "")
                    .replace(".gif", "");
                const exchangeMatch = ExchangeData.find(
                    (exchangeItem) => exchangeItem.address === blockchainAddressActive
                );

                const walletBalance = (walletBalancesForUser !== undefined && Array.isArray(walletBalancesForUser))
                    ? walletBalancesForUser.find((walletBalance) => walletBalance.projectId === projectId)
                    : undefined;
                const userBalanceAsString = walletBalance?.balance 
                    ? new Intl.NumberFormat(userLocale).format(walletBalance?.balance)
                    : undefined;
                const isServerManagedWallet = (walletBalance && walletBalance?.walletAccountType === "Server");
                
                    return (
                        <article key={`${projectId}`}>
                            <div
                                className="dark:bg-jacarta-700 dark:border-jacarta-700 border-jacarta-100 rounded-2.5xl block border bg-white p-[1.1875rem] transition-shadow hover:shadow-lg">
                                <figure className="relative">
                                    <Link href={`/collection/${itemLink}`}>
                                        <Image
                                            width={230}
                                            height={230}
                                            src={imageUrl}
                                            alt="item 5"
                                            className="w-full h-[230px] rounded-[0.625rem] object-cover"
                                        />
                                    </Link>
                                </figure>
                                <div className="mt-7 flex items-center justify-between">
                                    <Link href={`/collection/${itemLink}`}>
                  <span className="font-display text-jacarta-700 hover:text-accent text-base dark:text-white">
                    {projectName}
                  </span>
                                    </Link>

                                    {/* auction dropdown  */}
                                    <Auctions_dropdown
                                        classes="dark:hover:bg-jacarta-600 dropup hover:bg-jacarta-100 rounded-full "/>

                                </div>
                                <div className="mt-7 flex items-center justify-between">
                                    Minted: {calcCADRMintedAsString}
                                </div>
                                <div className="flex items-center justify-between">
                                    {userBalanceAsString ? (
                                        <div className="mt-7 flex items-center justify-between">Your
                                            Balance: {userBalanceAsString}</div>
                                    ) : <p></p>}
                                </div>

                                <div className="mt-8 flex items-center justify-between">
                                    {exchangeMatch && (<Image
                                        width={21}
                                        height={21}
                                        src={exchangeMatch.image}
                                        alt="Exchange"
                                        className="h-6 w-6"
                                    /> )}
                                    {isOwner && !isServerManagedWallet && (<div
                                        className="text-accent font-display text-sm font-semibold disabled"
                                    >
                                        External Managed
                                    </div>)}
                                </div>
                            </div>
                        </article>
                    )
                }
            ))}
        </div>
    );
};

export default CategoryItem;